import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

import { BrowserService } from 'webcommon/legacy-common';

@Injectable({
  providedIn: 'root',
})
export class CgmChatService {
  private readonly documentObj: Document;
  private readonly hideChatBotCss = 'hide-cgm-chat';
  private readonly renderer: Renderer2;
  private readonly scriptClassName = 'cgm-chat-script';

  private cgmChatBotHidden = true;
  webChatElement: HTMLElement | null;

  constructor(
    browserService: BrowserService,
    rendererFactory: RendererFactory2,
  ) {
    this.documentObj = browserService.getDocument();
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  load(cgmPortalChatUrl?: string): Promise<void> {
    const elementsByClassName = this.documentObj.getElementsByClassName(this.scriptClassName) ?? [];
    if (cgmPortalChatUrl && elementsByClassName.length === 0) {
        return new Promise<void>((resolve, reject) => {
            const script = this.documentObj.createElement('script');
            script.onload = () => {
              this.cgmChatBotHidden = false;
              resolve();
            };
            script.onerror = (e) => {
              reject(e);
            };
            script.className = this.scriptClassName;
            script.async = true;
            script.src = cgmPortalChatUrl + Date.now();
            this.documentObj.head.appendChild(script);
        });
    }
    return Promise.resolve();
  }

  getHiddenState() {
    return this.cgmChatBotHidden;
  }

  setHiddenState(cgmChatBotHidden: boolean) {
    if (cgmChatBotHidden) {
      this.hideChatBot();
    } else {
      this.showChatBot();
    }
  }

  hideChatBot() {
    const chatBotElement = this.getWebChatElement();
    if (chatBotElement && !this.cgmChatBotHidden) {
      this.renderer.addClass(chatBotElement, this.hideChatBotCss);
      this.cgmChatBotHidden = true;
    }
  }

  showChatBot() {
    const chatBotElement = this.getWebChatElement();
    if (chatBotElement && this.cgmChatBotHidden) {
      this.renderer.removeClass(chatBotElement, this.hideChatBotCss);
      this.cgmChatBotHidden = false;
    }
  }

  private getWebChatElement() {
    if (!this.webChatElement) {
      this.webChatElement = this.documentObj.getElementById('awc-webchat');
    }
    return this.webChatElement;
  }
}
